import { get } from "@/services/axiosUitils";

const BASE = "/food_scanner/measure/";

export interface MeasurePredictionItem {
  title: string;
  value: string;
  meta?: string;
  meal_context?: string;
  reading_type?: string;
}

export interface MeasureGroup {
  id: string;
  name: string;
  role?: string;
  member_count: number;
  owner_id?: string;
}

export interface MeasureWeightManagement {
  wms_score?: number;
  score_band?: string;
  prediction_tone?: string;
  weight_unit?: string;
  predicted_change_display?: string;
  levers?: Record<string, number>;
  primary_lever_key?: string;
  prescription_text?: string;
  lever_tips?: Record<string, string>;
}

export interface MeasurePageData {
  success?: { code: string; message: string };
  date_local?: string;
  is_today?: boolean;
  total_logged?: number;
  logged_on_date?: number;
  logged_on_date_pre_meal?: number;
  logged_on_date_post_meal?: number;
  "Powering This Prediction"?: MeasurePredictionItem[];
  "Weight Management"?: MeasureWeightManagement;
  group?: MeasureGroup;
}

class MeasureService {
  private static instance: MeasureService;

  private constructor() {}

  public static getInstance(): MeasureService {
    if (!MeasureService.instance) {
      MeasureService.instance = new MeasureService();
    }
    return MeasureService.instance;
  }

  async getMeasurePage(config?: { showNotification?: boolean; date?: string }): Promise<MeasurePageData | null> {
    const { date, ...rest } = config ?? {};
    const response = await get<MeasurePageData>(BASE, {
      showNotification: false,
      ...rest,
      ...(date ? { params: { date } } : {}),
    });
    if (response === undefined || response === null) return null;
    return response;
  }
}

export default MeasureService.getInstance();
